function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { forwardRef, PureComponent, createRef } from 'react';
import { Transition } from 'react-transition-group';
import { debounce } from '../../utilities/debounce.js';
import { classNames } from '../../utilities/css.js';
import { clamp } from '../../utilities/clamp.js';
import styles from './BulkActions.scss.js';
import { BulkActionMenu } from './components/BulkActionMenu/BulkActionMenu.js';
import { CheckableButton } from '../CheckableButton/CheckableButton.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { BulkActionButton } from './components/BulkActionButton/BulkActionButton.js';
import { Popover } from '../Popover/Popover.js';
import { ActionList } from '../ActionList/ActionList.js';
import { EventListener } from '../EventListener/EventListener.js';
import { InlineStack } from '../InlineStack/InlineStack.js';
var BUTTONS_NODE_ADDITIONAL_WIDTH = 64;
var BulkActionsInner = /*#__PURE__*/function (_PureComponent) {
  function BulkActionsInner() {
    var _this;
    _classCallCheck(this, BulkActionsInner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BulkActionsInner, [].concat(args));
    _this.state = {
      popoverVisible: false,
      containerWidth: 0,
      measuring: true
    };
    _this.containerNode = null;
    _this.buttonsNode = null;
    _this.moreActionsNode = null;
    _this.groupNode = /*#__PURE__*/createRef();
    _this.promotedActionsWidths = [];
    _this.bulkActionsWidth = 0;
    _this.addedMoreActionsWidthForMeasuring = 0;
    _this.handleResize = debounce(function () {
      var popoverVisible = _this.state.popoverVisible;
      if (_this.containerNode) {
        var containerWidth = _this.containerNode.getBoundingClientRect().width;
        if (containerWidth > 0) {
          _this.setState({
            containerWidth: containerWidth
          });
        }
      }
      if (popoverVisible) {
        _this.setState({
          popoverVisible: false
        });
      }
    }, 50, {
      trailing: true
    });
    _this.setButtonsNode = function (node) {
      _this.buttonsNode = node;
    };
    _this.setContainerNode = function (node) {
      _this.containerNode = node;
    };
    _this.setMoreActionsNode = function (node) {
      _this.moreActionsNode = node;
    };
    _this.togglePopover = function () {
      if (_this.props.onMoreActionPopoverToggle) {
        _this.props.onMoreActionPopoverToggle(_this.state.popoverVisible);
      }
      _this.setState(function (_ref) {
        var popoverVisible = _ref.popoverVisible;
        return {
          popoverVisible: !popoverVisible
        };
      });
    };
    _this.handleMeasurement = function (width) {
      var measuring = _this.state.measuring;
      if (measuring) {
        _this.promotedActionsWidths.push(width);
      }
    };
    return _this;
  }
  _inherits(BulkActionsInner, _PureComponent);
  return _createClass(BulkActionsInner, [{
    key: "numberOfPromotedActionsToRender",
    value: function numberOfPromotedActionsToRender() {
      var promotedActions = this.props.promotedActions;
      var _this$state = this.state,
        containerWidth = _this$state.containerWidth,
        measuring = _this$state.measuring;
      if (!promotedActions) {
        return 0;
      }
      var containerWidthMinusAdditionalWidth = Math.max(0, containerWidth - BUTTONS_NODE_ADDITIONAL_WIDTH);
      if (containerWidthMinusAdditionalWidth >= this.bulkActionsWidth || measuring) {
        return promotedActions.length;
      }
      var sufficientSpace = false;
      var counter = promotedActions.length - 1;
      var totalWidth = 0;
      while (!sufficientSpace && counter >= 0) {
        totalWidth += this.promotedActionsWidths[counter];
        var widthWithRemovedAction = this.bulkActionsWidth - totalWidth + this.addedMoreActionsWidthForMeasuring;
        if (containerWidthMinusAdditionalWidth >= widthWithRemovedAction) {
          sufficientSpace = true;
        } else {
          counter--;
        }
      }
      return clamp(counter, 0, promotedActions.length);
    }
  }, {
    key: "actionSections",
    value: function actionSections() {
      var actions = this.props.actions;
      if (!actions || actions.length === 0) {
        return;
      }
      if (instanceOfBulkActionListSectionArray(actions)) {
        return actions;
      }
      if (instanceOfBulkActionArray(actions)) {
        return [{
          items: actions
        }];
      }
    }
  }, {
    key: "rolledInPromotedActions",
    value: function rolledInPromotedActions() {
      var promotedActions = this.props.promotedActions;
      var numberOfPromotedActionsToRender = this.numberOfPromotedActionsToRender();
      if (!promotedActions || promotedActions.length === 0 || numberOfPromotedActionsToRender >= promotedActions.length) {
        return [];
      }
      var rolledInPromotedActions = promotedActions.map(function (action) {
        if (instanceOfMenuGroupDescriptor(action)) {
          return {
            items: _toConsumableArray(action.actions)
          };
        }
        return {
          items: [action]
        };
      });
      return rolledInPromotedActions.slice(numberOfPromotedActionsToRender);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        actions = _this$props.actions,
        promotedActions = _this$props.promotedActions;
      if (promotedActions && !actions && this.moreActionsNode) {
        this.addedMoreActionsWidthForMeasuring = this.moreActionsNode.getBoundingClientRect().width;
      }
      this.bulkActionsWidth = this.buttonsNode ? this.buttonsNode.getBoundingClientRect().width - this.addedMoreActionsWidthForMeasuring : 0;
      if (this.containerNode) {
        this.setState({
          containerWidth: this.containerNode.getBoundingClientRect().width,
          measuring: false
        });
      }
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        selectMode = _this$props2.selectMode,
        disabled = _this$props2.disabled,
        promotedActions = _this$props2.promotedActions,
        i18n = _this$props2.i18n,
        paginatedSelectAllText = _this$props2.paginatedSelectAllText,
        paginatedSelectAllAction = _this$props2.paginatedSelectAllAction,
        accessibilityLabel = _this$props2.accessibilityLabel,
        onToggleAll = _this$props2.onToggleAll,
        selected = _this$props2.selected,
        innerRef = _this$props2.innerRef,
        _this$props2$buttonSi = _this$props2.buttonSize,
        buttonSize = _this$props2$buttonSi === void 0 ? 'micro' : _this$props2$buttonSi,
        width = _this$props2.width,
        isSticky = _this$props2.isSticky;
      var actionSections = this.actionSections();
      var _this$state2 = this.state,
        popoverVisible = _this$state2.popoverVisible,
        measuring = _this$state2.measuring;
      var numberOfPromotedActionsToRender = this.numberOfPromotedActionsToRender();
      var promotedActionsMarkup = promotedActions && numberOfPromotedActionsToRender > 0 ? _toConsumableArray(promotedActions).slice(0, numberOfPromotedActionsToRender).map(function (action, index) {
        if (instanceOfMenuGroupDescriptor(action)) {
          return /*#__PURE__*/React.createElement(BulkActionMenu, Object.assign({
            key: index
          }, action, {
            isNewBadgeInBadgeActions: _this2.isNewBadgeInBadgeActions(),
            size: buttonSize
          }));
        }
        return /*#__PURE__*/React.createElement(BulkActionButton, Object.assign({
          key: index,
          disabled: disabled
        }, action, {
          handleMeasurement: _this2.handleMeasurement,
          size: buttonSize
        }));
      }) : null;
      var rolledInPromotedActions = this.rolledInPromotedActions();
      var activatorLabel = !promotedActions || promotedActions && numberOfPromotedActionsToRender === 0 && !measuring ? i18n.translate('Polaris.ResourceList.BulkActions.actionsActivatorLabel') : i18n.translate('Polaris.ResourceList.BulkActions.moreActionsActivatorLabel');
      var combinedActions = [];
      if (actionSections && rolledInPromotedActions.length > 0) {
        combinedActions = [].concat(_toConsumableArray(rolledInPromotedActions), _toConsumableArray(actionSections));
      } else if (actionSections) {
        combinedActions = actionSections;
      } else if (rolledInPromotedActions.length > 0) {
        combinedActions = _toConsumableArray(rolledInPromotedActions);
      }
      var hasTextAndAction = paginatedSelectAllText && paginatedSelectAllAction;
      var ariaLive = hasTextAndAction ? 'polite' : undefined;
      var checkableButtonProps = {
        accessibilityLabel: accessibilityLabel,
        selected: selected,
        onToggleAll: onToggleAll,
        disabled: disabled,
        ariaLive: ariaLive,
        ref: innerRef
      };
      var actionsPopover = actionSections || rolledInPromotedActions.length > 0 || measuring ? /*#__PURE__*/React.createElement("div", {
        className: styles.Popover,
        ref: this.setMoreActionsNode
      }, /*#__PURE__*/React.createElement(Popover, {
        active: popoverVisible,
        activator: /*#__PURE__*/React.createElement(BulkActionButton, {
          disclosure: true,
          showContentInButton: !promotedActionsMarkup,
          onAction: this.togglePopover,
          content: activatorLabel,
          disabled: disabled,
          indicator: this.isNewBadgeInBadgeActions(),
          size: buttonSize
        }),
        preferredAlignment: "right",
        onClose: this.togglePopover
      }, /*#__PURE__*/React.createElement(ActionList, {
        sections: combinedActions,
        onActionAnyItem: this.togglePopover
      }))) : null;
      var groupContent = promotedActionsMarkup || actionsPopover ? /*#__PURE__*/React.createElement(InlineStack, {
        gap: "300",
        blockAlign: "center"
      }, /*#__PURE__*/React.createElement(CheckableButton, checkableButtonProps), /*#__PURE__*/React.createElement(InlineStack, {
        gap: "100",
        blockAlign: "center"
      }, promotedActionsMarkup, actionsPopover)) : null;
      if (!groupContent) {
        return null;
      }
      var group = /*#__PURE__*/React.createElement(Transition, {
        timeout: 0,
        in: selectMode,
        key: "group",
        nodeRef: this.groupNode
      }, function (status) {
        var groupClassName = classNames(styles.Group, !isSticky && styles['Group-not-sticky'], status && styles["Group-".concat(status)]);
        return /*#__PURE__*/React.createElement("div", {
          className: groupClassName,
          ref: _this2.groupNode,
          style: width ? {
            width: width
          } : undefined
        }, /*#__PURE__*/React.createElement(EventListener, {
          event: "resize",
          handler: _this2.handleResize
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.ButtonGroupWrapper,
          ref: _this2.setButtonsNode
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.ButtonGroupInner
        }, groupContent)));
      });
      return /*#__PURE__*/React.createElement("div", {
        ref: this.setContainerNode
      }, group);
    }
  }, {
    key: "isNewBadgeInBadgeActions",
    value: function isNewBadgeInBadgeActions() {
      var actions = this.actionSections();
      if (!actions) return false;
      var _iterator = _createForOfIteratorHelper(actions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var action = _step.value;
          var _iterator2 = _createForOfIteratorHelper(action.items),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _item$badge;
              var item = _step2.value;
              if (((_item$badge = item.badge) === null || _item$badge === void 0 ? void 0 : _item$badge.tone) === 'new') return true;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }]);
}(PureComponent);
function instanceOfBulkActionListSectionArray(actions) {
  var validList = actions.filter(function (action) {
    return action.items;
  });
  return actions.length === validList.length;
}
function instanceOfBulkActionArray(actions) {
  var validList = actions.filter(function (action) {
    return !action.items;
  });
  return actions.length === validList.length;
}
function instanceOfMenuGroupDescriptor(action) {
  return 'title' in action;
}
var BulkActions = /*#__PURE__*/forwardRef(function BulkActions(props, ref) {
  var i18n = useI18n();
  return /*#__PURE__*/React.createElement(BulkActionsInner, Object.assign({}, props, {
    i18n: i18n,
    innerRef: ref
  }));
});
export { BulkActions };